/* eslint-disable import/no-restricted-paths */
import { IMicrofrontendsAPI } from '../../../node/services/microfrontends/types';
import { openAuthModal } from '../../repositories/header-frontend/v2/open-auth-modal/helpers';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    header: {
      openAuthModal,
    },
  };
}
